import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import { LoaderStyles } from "./Loader.styles";
export var Loader = function () {
    var sx = LoaderStyles();
    return (_jsx(Box, { sx: sx.wrapper, children: _jsx(LinearProgress, { color: "primary" }) }));
};
